import { Authenticator } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import { useDispatch } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Details from './details/Details';
import Header from './Header';
import Overview from './overview/Overview';
import { resetStore } from './store/ExperimentSlice';

export default function Main() {
    const dispatch = useDispatch()

    const services = {
        async handleSignIn(input) {
            let output = await Auth.signIn(input);
            dispatch(resetStore())
            return output;
        }
    }

    function onSignOut(signOut) {
        dispatch(resetStore())
        signOut()
    }

    return (
        <>
            <Authenticator services={services} hideSignUp>
                {({ signOut, user }) => (
                    <BrowserRouter>
                        <Header onSignOutClicked={function () { return onSignOut(signOut); }} />
                        <Routes>
                            <Route path="/" element={
                                <Overview username={user.username} />
                            } />
                            <Route path="/access/*" element={
                                <Details onSignOut={function () { return onSignOut(signOut); }}/>
                            } />
                        </Routes>
                    </BrowserRouter>
                )}
            </Authenticator>
        </>
    );
}
